import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { RoomType } from '../../shared/room-type.model';
import { RoomTypeService } from '../../shared/room-type.service';

@Component({
  selector: 'app-room-type-translation-modal',
  templateUrl: './room-type-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class RoomTypeTranslationModalComponent {
  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private roomTypeService: RoomTypeService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<RoomTypeTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getRoomType();
  }

  roomType: RoomType = null;
  roomTypeCopy = null;

  modalTitle = this.data.title;
  roomTypeId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  // Referenced from app-item-detail-form-actions
  onSavedRoomTypeTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'description'];

    if (!fields.some((field) => formData[field] !== this.roomTypeCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.roomTypeService.saveRoomType(this.roomType.id, formData, this.language.lang).subscribe({
      next: (response) => {
        this.alertService.open('TRANSLATION_SAVED');

        this.sendingForm = false;

        this.ref.close(response);
      },
      error: (response) => {
        this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

        this.sendingForm = false;
      },
    });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getRoomType() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.roomTypeService.getRoomType(this.roomTypeId, params).subscribe((roomType) => {
      this.roomType = roomType;
      this.roomTypeCopy = { ...this.roomType };

      this.setRoomTypeTranslationForm();

      this.form.patchValue(this.roomType);
    });
  }

  private setRoomTypeTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: '',
    });
  }
}

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

 this.form = this.formBuilder.group({
      name: [
        this.roomType.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.roomType.description],
    });

*/
